import { useData } from "@hooks/useData";
import { ChainMenuData, iChainMenuData } from "@models/ChainMenuData";
import Http from "@core/fetch";
import { components } from "@apiSchema";


async function getMenu(chainId: number): Promise<iChainMenuData> {
    const data: components["schemas"]["MenuItemsVIewModel"] = await Http.get('get chain menu data', { chainId });
    return new ChainMenuData({ apiModel: data });
}

export default function useMenu(chainId: number) {
    return useData(new ChainMenuData(), getMenu, chainId);
}
